export enum AssignmentResultType {
    None = 0,
    ActualPoints = 1,
    PercentageValues = 2,
    GradingStructures = 3,
}
